// utils/location.ts
import { ref } from 'vue';

// реактивная копия текущего url, чтобы ссылки (например, пагинации) обновлялись после replaceState
const currentHref = ref(window.location.href);

// вызывать после смены url в обход функций этого файла (например, router.push)
export const syncLocation = () => {
  currentHref.value = window.location.href;
};

window.addEventListener('popstate', syncLocation);

const replaceState = (fullPath: string) => {
  window.history.replaceState(window.history.state, '', fullPath);
  syncLocation();
};

export const getLocation = () => {
  const url = new URL(window.location.href);

  return {
    path: url.pathname,
    fullPath: `${url.pathname}${url.search}${url.hash}`,
    search: url.search,
    hash: url.hash,
    query: Object.fromEntries(url.searchParams),
    searchParams: url.searchParams,
  };
};

export const setQueryParam = (name: string, value: string | number) => {
  const url = new URL(window.location.href);

  url.searchParams.set(name, String(value));

  replaceState(`${url.pathname}${url.search}${url.hash}`);

  return `${url.pathname}${url.search}${url.hash}`;
};

export const getQueryParam = (name?: string): string | null => {
  if (!name) return null;

  return new URLSearchParams(window.location.search).get(name);
};

export const getPageUrl = (pagingKey: string, page: string | number): string => {
  const url = new URL(currentHref.value);

  if (+page === 1) {
    url.searchParams.delete(pagingKey);
  } else {
    url.searchParams.set(pagingKey, String(page));
  }

  return `${url.pathname}${url.search}${url.hash}`;
};

export const replaceQueryParam = (name: string, value: string | number): string => {
  const url = new URL(window.location.href);

  if (+value === 1) {
    url.searchParams.delete(name);
  } else {
    url.searchParams.set(name, String(value));
  }

  const fullPath = `${url.pathname}${url.search}${url.hash}`;

  replaceState(fullPath);

  return fullPath;
};

export const replaceUrl = (urlValue: string): string => {
  const url = new URL(urlValue, window.location.origin);
  const fullPath = `${url.pathname}${url.search}${url.hash}`;

  replaceState(fullPath);

  return fullPath;
};
